module.exports = __webpack_public_path__ + "static/media/SpartanHorseman.23c3814e.jpg";